export default [
  {
    path: 'scientific-topics',
    name: 'scientific-topics',
    component: () => import('@/views/pages/scientific-topics/Index.vue'),
    meta: {
      pageTitle: 'Scientific topics',
      breadcrumb: [
        {
          text: 'Scientific topics',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
